import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Post } from './post.model';
import { PostActions, PostActionTypes } from './post.actions';

export const KEY = 'posts';

export interface State extends EntityState<Post> {
  // additional entities state properties
}

export const adapter: EntityAdapter<Post> = createEntityAdapter<Post>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export function reducer(state = initialState, action: PostActions): State {
  switch (action.type) {
    case PostActionTypes.LoadPostsComplete: {
      return adapter.addMany(action.payload.posts, state);
    }

    default: {
      return state;
    }
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
